import * as paymentmethods from 'smg/customer-api/paymentoptions';
import { Redirect, Session } from 'smg/customer-api/session';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { UUID } from 'smg/uuid';
import { DrawPaymentOption, PromptNewPaymentOption } from '../payments';

export default async function main() {
    if (await Redirect()) {
        return;
    }
    const sess = await Session();
    const cardContainer = document.querySelector<HTMLElement>('#payment-methods-container');

    const newPaymentMethodBtn = document.querySelector('#new-payment-method');
    newPaymentMethodBtn?.addEventListener('click', () => {
        void PromptNewPaymentOption(sess, 'Add payment method', [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT, models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK]).then(drawPayment);
    });

    const paymentOptions = await paymentmethods.GetPaymentOptions({
        'data': 'fullName,company,addressLine1,addressLine2,city,stateID,zip,countryID,phone,email,creditCardFirst6,creditCardLast4,creditCardExpirationDate,key,paymentOptionTypeID,bankType,accountType',
        'sort': 'created asc',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip valid:yes',
    });

    const drawPayment = async (payment: models.PaymentOption) => {
        const paymentEl = (await DrawPaymentOption(payment)).querySelector<HTMLElement>('div');
        const cardEl = template.Clone('#card-template').firstElementChild as HTMLElement;
        const paymentContainer = cardEl.querySelector('.payment-container');
        const editBtn = cardEl.querySelector('.edit-btn');
        const deleteBtn = cardEl.querySelector('.delete-btn');

        paymentContainer?.append(paymentEl as HTMLElement);

        editBtn?.addEventListener('click', async () => {
            await PromptNewPaymentOption(sess, 'Update', [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT, models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK], payment).then(newPayment => {
                payment = newPayment;
                void DrawPaymentOption(newPayment, undefined, paymentEl as HTMLElement);
            });
        });

        deleteBtn?.addEventListener('click', () => {
            void paymentmethods.DeletePaymentOption(payment.id || '').
                then(() => {
                    cardEl.parentElement?.removeChild(cardEl);
                    const undoLinkID = `undo-${UUID()}`;
                    const t = toast.Success(`Removed payment method. <a href="#" class="text-white text-decoration-underline" id="${undoLinkID}">Undo</a>`);
                    const undo = document.querySelector(`#${undoLinkID}`) as HTMLAnchorElement;
                    undo.addEventListener('click', e => {
                        e.preventDefault();
                        t?.dispose();
                        void paymentmethods.RestorePaymentOption(payment.id || '');
                        void drawPayment(payment);
                    });
                });
        });
        cardContainer?.insertBefore(cardEl, cardContainer.firstChild);
    };
    for (const paymentMethod of paymentOptions) {
        await drawPayment(paymentMethod);
    }
}